export const IDLE = 'idle'
export const PENDING = 'pending'
export const SUCCEEDED = 'succeeded'
export const FAILED = 'failed'

const LOADING_STATUSES = [IDLE, PENDING, SUCCEEDED, FAILED] as const
export type LoadingStatus = (typeof LOADING_STATUSES)[number]
